<template>
  <div class="popup-item">
    <div class="d-flex align-items-center">
      <img :src="data.image" width="40" height="40" class="popup-item__img" alt="item">
      <div class="popup-item__content" v-html="data.html_markup" />
    </div>
    <a :href="data.target" rel="noopener" class="popup-item__btn d-none d-sm-block" target="_blank">{{ data.button_label }}</a>
    <a :href="data.target" rel="noopener" class="popup-item__btn-mobile d-sm-none" target="_blank" />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style lang="scss">
.blue {
  font-weight: bold;
  color: #008FFF;
}
.red {
  font-weight: bold;
  color: #EF2C2C;
}
</style>

<style lang="scss" scoped>
.d-flex {
  display: flex;
}
.align-items-center {
  align-items: center;
}
.popup-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  position: relative;
  background-color: #F2F5F7;
  margin: 0 1px;

  & + .popup-item {
    border-top: 1px solid #C1D1DF;
  }

  .popup-item__img {
    border-radius: 50%;
    flex-shrink: 0;
  }

  .popup-item__btn {
    flex-shrink: 0;
    border: none;
    background: #E1E4E5;
    border-radius: 4px;
    color: #008FFF;
    font-size: 14px;
    line-height: 18px;
    padding: 4px 12px;
    outline: none;
    cursor: pointer;
    text-decoration: none;

    &:hover, &.focus {
      background: #008FFF;
      color: white;
      text-decoration: none;
    }
  }

  .popup-item__btn-mobile {
    flex-shrink: 0;
    width: 10px; height: 16px;
    background: url(~@/node_modules/@pp-frontend/authorization/assets/expand.svg) no-repeat;
    background-size: 10px 16px;
    outline: none;
    &::before {
      content: '';
      position: absolute;
      left: 0; top: 0;
      width: 100%; height: 100%;
      z-index: 10;
    }
  }

  .popup-item__content {
    display: inline-block;
    font-size: 14px;
    line-height: 18px;
    color: #596D7B;
    margin: 0 16px;
  }
}
</style>
